import { VehicleAlertListInputFilter } from './vehicle-alert-list-input-filter.model';
import { VehicleAlertListInputOrderBy } from './vehicle-alert-list-input-order-by.model';


export class VehicleAlertListInput implements IVehicleAlertListInput {
    /** The time zone */
    timeZone!: string;
    /** The from date */
    fromDate!: string;
    /** The to date */
    toDate!: string;
    /** The search from data */
    search!: string;
    /** The Page no */
    page!: number;
    /** The no of records on per page */
    noOf!: number;
    filter!: VehicleAlertListInputFilter[];
    orderBy!: VehicleAlertListInputOrderBy[];

    constructor(data?: IVehicleAlertListInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZone = _data["timeZone"];
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.search = _data["search"];
            this.page = _data["page"];
            this.noOf = _data["noOf"];
            if (Array.isArray(_data["filter"])) {
                this.filter = [] as any;
                for (let item of _data["filter"])
                    this.filter!.push(VehicleAlertListInputFilter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(VehicleAlertListInputOrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VehicleAlertListInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleAlertListInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZone"] = this.timeZone;
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["search"] = this.search;
        data["page"] = this.page;
        data["noOf"] = this.noOf;
        if (Array.isArray(this.filter)) {
            data["filter"] = [];
            for (let item of this.filter)
                data["filter"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IVehicleAlertListInput {
    /** The time zone */
    timeZone: string;
    /** The from date */
    fromDate: string;
    /** The to date */
    toDate: string;
    /** The search from data */
    search: string;
    /** The Page no */
    page: number;
    /** The no of records on per page */
    noOf: number;
    filter: VehicleAlertListInputFilter[];
    orderBy: VehicleAlertListInputOrderBy[];
}

